import { intDateFromDate, weekToDate } from 'components/main/main.component'
import React, { FC } from 'react'
import styled from 'styled-components'

const StyledGroupTitle = styled.div`
  font-family: var(--font-plex);
  /* margin-top: 30px; */
  margin-bottom: 30px;
  text-align: center;
`

const KW = styled.div`
  font-weight: 500;
  font-size: 15px;
  line-height: 1.2em;
  margin-bottom: 5px;
`
const Weekdates = styled.span`
  font-weight: 500;
  font-size: 15px;
`

const Title = styled.div`
  font-weight: 200;
  font-size: 32px;
  line-height: 1.5em;
  letter-spacing: -0.3px;
`

export const GroupTitle: FC<{
  week?: string | number
  lang: 'de' | 'fr'
  labels: string[]
}> = ({ children, week, lang = 'de', labels }) => {
  return (
    <StyledGroupTitle>
      {week && (
        <KW>
          {labels[0]} {week} |{' '}
          <Weekdates>{getDateByWeek(2022, +week, lang).join(' - ')}</Weekdates>
        </KW>
      )}
      <Title>{children}</Title>
    </StyledGroupTitle>
  )
}

const dateFormat = {
  day: 'numeric',
  month: 'long'
  // year: 'numeric'
}

export const getDateByWeek = (
  year: number,
  week: number,
  locale: 'de' | 'fr' = 'de'
) => {
  function addDays(date: Date, days: number) {
    var result = new Date(date)
    result.setDate(result.getDate() + days)
    return result
  }

  // Create a date for 1 Jan in required year
  var d = new Date(year, 0)
  // Get day of week number, sun = 0, mon = 1, etc.
  var dayNum = d.getDay()
  // Get days to add
  var requiredDate = --week * 7

  // For ISO week numbering
  // If 1 Jan is Friday to Sunday, go to next week
  if (dayNum != 0 || dayNum > 4) {
    requiredDate += 7
  }

  // Add required number of days
  d.setDate(1 - d.getDay() + ++requiredDate)
  let showd = d.toLocaleDateString(locale + '-CH', dateFormat)
  return [showd, addDays(d, 6).toLocaleDateString(locale + '-CH', dateFormat)]
}
